<template>
  <div>
    <div v-if="accountStatus.subscription_status === 'active'">
      You currently have an active subscription. Please cancel your subscription
      in Billing first before proceeding with account deletion.
    </div>
    <div v-else class="account-info">
      <div v-if="accountStatus.subscription_status === 'canceled'">
        Your subscription has been canceled, but it still has time remaining
        before access ends. Consider deleting your account after your
        subscription ends to get the most out of your subscription.
      </div>
      <div>
        When you delete your account, you'll lose everything in your account,
        including your reading history, highlights, and messages. This action is
        permanent and cannot be undone.
      </div>
      <div
        v-if="
          accountStatus.user_doc_count > 0 ||
          accountStatus.highlight_count > 0 ||
          accountStatus.workout_count > 0
        "
        class="benefits-lost-section"
      >
        <div>By deleting your account, you'll permanently lose:</div>
        <div class="benefits-lost">
          <div v-if="accountStatus.user_doc_count > 0">
            Books in your library: {{ accountStatus.user_doc_count }}
          </div>
          <div v-if="accountStatus.highlight_count > 0">
            Saved highlights: {{ accountStatus.highlight_count }}
          </div>
          <div v-if="accountStatus.workout_count > 0">
            Completed exercises: {{ accountStatus.workout_count }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AccountStatus } from '@/models/interfaces'

defineProps<{ accountStatus: AccountStatus }>()
</script>

<style scoped lang="scss">
.account-info {
  text-align: left;
}

.account-info > :not(:last-child) {
  margin-bottom: 18px;
}

.benefits-lost-section {
  text-align: left;
}

.benefits-lost {
  margin-top: 5px;
}
</style>
